import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = 'Laser';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Sparkle Redberry] </Text><a href="https://blogs.sans.org/pen-testing/files/2016/05/PowerShellCheatSheet_v41.pdf">SANS' PowerShell Cheat Sheet</a></Flex>),
  ];
  const assignment = `I'm Sparkle Redberry and Imma chargin' my laser!
Problem is: the settings are off.
Do you know any PowerShell?
It'd be GREAT if you could hop in and recalibrate this thing.
It spreads holiday cheer across the Earth ...

... when it's working!`;
  const data = useStaticQuery(graphql`
    query {
      cranLazer: file(relativePath: { eq: "cranLazer.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps1: file(relativePath: { eq: "ps1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps2: file(relativePath: { eq: "ps2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps3: file(relativePath: { eq: "ps3.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps4: file(relativePath: { eq: "ps4.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps5: file(relativePath: { eq: "ps5.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps6: file(relativePath: { eq: "ps6.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps7: file(relativePath: { eq: "ps7.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps8: file(relativePath: { eq: "ps8.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps9: file(relativePath: { eq: "ps9.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps10: file(relativePath: { eq: "ps10.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ps11: file(relativePath: { eq: "ps11.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      psAPI: file(relativePath: { eq: "psAPI.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      psDone: file(relativePath: { eq: "psDone.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      powerStart: file(relativePath: { eq: "powerStart.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }




    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranLazer.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Hermey Hall, Laboratory</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
      assignment={assignment}
    >
      <br />
      <Img fluid={data.powerStart.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text mt={2}>According to the API we need to find the values for refraction, temprature, angle and gases.</Text>
      <Img fluid={data.psAPI.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '49vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>We are suggested to start with a file. Then we will get a series of <code>riddles</code> that give us hints about which PowerShell commands to use.</Text>
      <Img fluid={data.ps1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Hint at Command History!</Text>
      <Img fluid={data.ps2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '55vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>History item #7 has the <code>angle</code> value we look for! Also lets have a closer look at entry number 9.</Text>
      <Img fluid={data.ps3.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>Hint at environment variables!</Text>
      <Img fluid={data.ps4.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>Environment variable <code>riddle</code> gives us detiailed instructions of what to do next.</Text>
      <Img fluid={data.ps5.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '55vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>Great! <code>Refraction</code> is found!</Text>
      <Img fluid={data.ps6.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '45vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>We also got another riddle.</Text>
      <Img fluid={data.ps7.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>Executing the command from the riddle gets us <code>temperature</code>.</Text>
      <Img fluid={data.ps8.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>The content of the child of "depths" with the longest file length does not give us any value we need, but we get a new riddle.</Text>
      <Img fluid={data.ps9.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '75vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>Killing processes in the correct order and getting the content of <code>/shall/see</code> leads to another riddle.</Text>
      <Img fluid={data.ps10.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '55vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />


      <Text my={2}>This will be the final step to find the values for gases. Dear <code>grep</code>, you are being missed.</Text>
      <Img fluid={data.ps11.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Time to update the correct configuration of the laser. It worked!</Text>
      <Img fluid={data.psDone.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

    </Entry>
  )

};
